import KingfisherService from '../utils/request';
import FetchService from '../utils/fetch';


class ProjectService {
    /**
     * Creates an instance of ProjectService.
     * @memberOf  ProjectService
     */
    constructor() {
        this.module = 'project';
        this.kingfisherService = new KingfisherService({});
        this.fetchService = new FetchService({});
    }

    /**
     * 获取所有
     * @returns {jQuery|Deferred} Ajax请求返回并处理后的Promise
     */
    getAll(type) {
        return this.kingfisherService.get(`/repo/kf-project/get-all/${type}`).then(response => {
            return response;
        });
    }

  /**
   * 获取查询的tags
   * @returns {jQuery|Deferred} Ajax请求返回并处理后的Promise
   */
  getTags(projectId,name) {
    if(""==name){
      name=null;
    }
    return this.kingfisherService.get(`/repo/kf-details/get-tags/${projectId}/${name}`).then(response => {
      return response;
    });
  }

  /**
   * 获取所有
   * @returns {jQuery|Deferred} Ajax请求返回并处理后的Promise
   */
  getDeatil(projectId,page,size,tags,name) {
    if(name==undefined || ""==name){
      name=null;
    }
    if(tags==undefined || (tags&& tags=='全部')){
      tags=0
    }
    return this.kingfisherService.get(`/repo/kf-details/get-details/${projectId}/${page}/${size}/${tags}/${name}`).then(response => {
      return response;
    });
  }

  /**
   * 获取所有
   * @returns {jQuery|Deferred} Ajax请求返回并处理后的Promise
   */
  getSearchDeatil(projectId,page,size,name) {
    return this.kingfisherService.get(`/repo/kf-details/get-details-fuzzy/${projectId}/${page}/${size}/${name}`).then(response => {
      return response;
    });
  }


}

export default new ProjectService();
